import React, {useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'

import {toast} from 'react-toastify'
import { ToastMessageContainer } from '../../../../../../_ePulse/layout/components/ToastMessageContainer'
import { DELETE_LAB_ROOM } from '../../../GraphQLQueries/ProductOffering'
import useMutationApi from '../../../../../../hooks/useMutation'


export default function DeleteLabModel(props: any) {


  const [id, setid] = useState(props.labData?.labId);

  const [isloading, setLoading] = useState(false);
    const { createData, loading, error, data } = useMutationApi(DELETE_LAB_ROOM);
    
    
    const deleteCallAPI = async () => {
      try{
        await createData({testRoomId:id});
        toast.success(`Lab ${props.labData?.roomName} deleted sucessfully!`);
        props.closeModal();
      }catch(err){
        console.log("error deleting lab: ",err);
        toast.error(`Error deleting Lab ${props.labData?.roomName}`);
      }
    }


  return (
    <div>
      <ToastMessageContainer />
      <Modal
        show={props.modalState}
        dialogClassName='ePulse-modal ePulse-modal-50w'
        onHide={() => props.closeModal()}
        backdrop='static'
      >
        <Modal.Header className='border-0' closeButton>
          <span className='fs-3 fw-bold'>Delete {props.labData?.roomName}</span>
        </Modal.Header>
        <Modal.Body className='container' />
        <div className='ePulse-modal-content'>
          <span className='fs-3 fw-semibold ms-4'>Are you sure, you want to delete?</span>
          <div className='btn-row'>
            <button className='ePulse-btn-primary' type='button' onClick={() => deleteCallAPI()}>
              {!isloading && 'Delete'}
              {isloading && (
                <span className='indicator-progress' style={{display: 'block'}}>
                  Please wait...{' '}
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )}
            </button>
          </div>
        </div>
      </Modal>
    </div>
  )
}